import ReactGA from "react-ga4";

export default function trackPageView(title) {
    ReactGA.send({
        hitType: "pageview",
        page: window.location.pathname + window.location.search,
        title,
    });
}
